import React from 'react';
import { Text } from '@atlaskit/primitives';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import MessageTimeBadge from '../MessageTimeBadge';
import { styles } from './styles';
import { getIsSameDay } from '../../../../utils/dateTime';

const errorColor = '#FF5630';
const textColor = '#172B4D';

const MessageItem = ({
  isHuman,
  nextDate,
  id,
  messageItem,
}) => {
  const timeBadge = !getIsSameDay(messageItem.created_at, nextDate);

  return (
    <>
      <div id={`${id}`} />
      <div style={{ display: 'flex', alignSelf: 'flex-start', ...(isHuman ? styles.human : {}) }}>
        <div style={{ ...styles.messageItem, ...(!isHuman ? styles.messageItemAi : {}) }}>
          <div style={{ minWidth: '90px', ...(isHuman ? styles.messageItemHuman : {}) }}>
            <div style={isHuman ? styles.messageHuman : {}}>
              <Text
                style={{
                  color: messageItem.type === 'error' ? errorColor : textColor,
                }}
                type="info"
              >
                <ReactMarkdown>{messageItem.text}</ReactMarkdown>
              </Text>
            </div>
          </div>
        </div>
      </div>
      {timeBadge && (
        <div
          style={{
            transform: 'rotate(180deg)',
            direction: 'ltr',
            width: '100%!important',
            maxWidth: 'unset!important',
            margin: 18,
          }}
        >
          <MessageTimeBadge date={messageItem.created_at} />
        </div>
      )}
    </>
  );
};

const areEqual = (prevProps, nextProps) => (
  prevProps.messageItem === nextProps.messageItem
  && prevProps.isTypingMessage === nextProps.isTypingMessage
);
MessageItem.defaultProps = {
  nextDate: null, // Задаємо дефолтне значення, якщо nextDate не передано
};
MessageItem.propTypes = {
  isHuman: PropTypes.bool.isRequired,
  nextDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  messageItem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    created_at: PropTypes.string.isRequired,
    message_rate: PropTypes.number,
    text: PropTypes.string,
    saved_at: PropTypes.string,
    suggestingQuestions: PropTypes.arrayOf(PropTypes.string),
    continueStatus: PropTypes.bool,
    nextToken: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tokenIndex: PropTypes.number,
    type: PropTypes.string,
  }).isRequired,
};

export default React.memo(MessageItem, areEqual);
